import React, { useEffect } from 'react';
import { useStoreon } from 'storeon/react';
import PropTypes from 'prop-types';
import Select from "../Select";
import Input from "../Input";
import { useFormContext } from "react-hook-form";
import getShipTo from "../../getShipTo/getShipTo";
import emailValidationRules from '../../constants/validateEmail';

const DealerContactInformationMiwindows = ( props ) => {
    const { index, number = true, site = '' } = props;
    const { groups } = useStoreon( 'groups' );
    const { watch, trigger } = useFormContext();
    const { service_type: serviceType = '' } = watch()

    // These two fields are conditional and used to show additional fields base on value.
    // We have to trigger validation when one of theme go changed so that we can use our logic
    // for fieldsets visibility.

    useEffect( () => {
        trigger();
    }, [trigger, serviceType] );

    // PGT dealer location options come from the webform (service_request_dealer_new),
    // passed by the controller via drupalSettings, so regions stay editable in Drupal
    // without rebuilding this React bundle.
    const {account, region} = getShipTo();
    const ds = (typeof window !== 'undefined' && window.drupalSettings) || {};
    const dealerLocations = (ds.milgardServiceRequest && ds.milgardServiceRequest.dealerLocations) || null;
    const locationOptions = dealerLocations
        ? Object.keys(dealerLocations).map((value) => ({ value: String(value), label: dealerLocations[value] }))
        : [];
    const defaultLocation = locationOptions.some((o) => o.value === region) ? region : '';

    return (
        <fieldset className="form-block" disabled={groups[index].disabled}>
            <legend className="form-block__title">{number ? index + 1 + '. ' : ''}Dealer Contact Information</legend>
            <div className="row">
                {site === 'pgt' && locationOptions.length ? (
                    <div className="col col-12 col-md-6 col-xl-3">
                        <Select
                            label="Select (Purchase) Location"
                            name="location"
                            options={locationOptions}
                            rules={{
                                required: 'This field is required.',
                            }}
                            defaultValue={defaultLocation}
                        />
                    </div>
                ) : (
                    <Input
                        name="location"
                        defaultValue="71"
                        type="hidden"
                        isRequired={false}
                    />
                )}
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Ship To Account #"
                        name="dealer_account"
                        rules={{
                            required: 'This field is required.',
                        }}
                        defaultValue={account}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer Contact’s First Name"
                        name="dealer_first_name"
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer Contact’s Last Name"
                        name="dealer_last_name"
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer‘s Email Address"
                        name="dealer_email_address"
                        type="email"
                        rules={emailValidationRules()}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer’s Phone Number"
                        name="dealer_phone"
                        rules={{
                            required: 'This field is required.',
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: 'The phone number should contain only 10 digits (ex. 5555555555) with no spaces.',
                            },
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-6 col-xl-3">
                    <Select
                        label="Service Type"
                        name="service_type"
                        options={[
                            {
                                value: 'Service Request',
                                label: 'Service request',
                            },
                            {
                                value: 'Mailed Parts – Dealer',
                                label: 'Ship parts to dealer',
                            },
                            {
                                value: 'Mailed Parts',
                                label: 'Ship parts to customer',
                            },
                        ]}
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
            </div>

            {!groups[index].disabled && groups[index + 1] && groups[index + 1].disabled && (
                <div className={'form-block__error'}>
                    You must fill in all required fields prior to moving to the next section.
                </div>
            )}
        </fieldset>
    );
};

DealerContactInformationMiwindows.propTypes = {
    index: PropTypes.number.isRequired,
};

export default DealerContactInformationMiwindows;
